import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ProjectService } from 'src/app/Services/project.service';

@Component({
    selector: 'app-apply-coupon',
    templateUrl: './apply-coupon.component.html',
    styleUrl: './apply-coupon.component.css',
    standalone: false
})
export class ApplyCouponComponent {
	applyCouponForm: UntypedFormGroup;
  isError = false;
  errorMsg = '';
  isloading = false;
  constructor(public dialogRef: MatDialogRef<ApplyCouponComponent>,private _projectService:ProjectService){
    this.applyCouponForm = new UntypedFormGroup({
      coupon : new UntypedFormControl('', [Validators.required]),

		})
  }
  onKey(){
    this.isError = false;
    this.errorMsg = '';
  }

  applyAction(){
    if (this.applyCouponForm.invalid || this.isloading) {
      this.applyCouponForm.markAllAsTouched();
      return;
    }

    this.isloading = true;
    const couponCode = (this.applyCouponForm.value.coupon || '').trim();
    this._projectService.applyCoupon(couponCode).subscribe((data: any) => {
      this.isloading = false;
      if(data || data == true || data == 'true'){
        this.dialogRef.close({ couponCode });
      }
    },err=>{  
      this.isloading = false;
      this.errorMsg = err.error.message;
      this.isError = true;
    })
  }
}
